import { Lock } from 'lucide-react';
import { cn } from '../utils/cn';

interface ConfidentialBadgeProps {
  className?: string;
}

/**
 * A small inline badge indicating that evidence is marked as confidential.
 * Shown to privileged users who can still see the real content, so they know
 * other users will see a redacted placeholder instead.
 */
export const ConfidentialBadge = ({ className }: ConfidentialBadgeProps) => {
  return (
    <span
      className={cn('badge badge-amber backdrop-blur-sm', className)}
      title="This evidence is marked as confidential"
    >
      <Lock className="w-3 h-3" />
      <span>Confidential</span>
    </span>
  );
};
